module.exports = __webpack_public_path__ + "img/banner_1931.7c3ea9f3.png";